import React from 'react';
import axios from 'axios';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

export const CardOfAM = ({closeModal, id}) => {
    const [users, setUsers] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);


    React.useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get(`/api/get-o-user?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('Ошибка системы.');
            } else {
                setWarning('');
                setUsers([response.data]);
            }
        })
        .catch(error => {
            console.error('Ошибка при получении данных: ', error);
            setWarning('Ошибка получения данных: '+error.response.data.message || error.message);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        });
    }, [reload, id]);

    return (
    <>
        <div className={styles.liningOver} onClick={closeModal}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
            <div className={styles.header}>
                <div style={{display: 'flex'}}>
                    <h1>Карточка арбитражного управляющего</h1>
                </div>
                <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                </svg>
            </div>
            <div className={styles.main}>
                {loading ? (
                 <Loading />
                ) : warning ? (
                    <a>{warning}</a>
                ) : (
                    users.map((user) => (
                        <>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                <div>
                                    <h2 style={{marginTop: '0px'}}>ФИО:</h2>
                                    <a>{user.lastname} {user.firstname} {user.surname}</a>
                                </div>
                            </div>
                            <h2>Email:</h2>
                            <a>{user.email}</a>
                            <h2>Регион основной деятельности:</h2>
                            <a>{user.branch}</a>
                            <h2>Тип учётной записи:</h2>
                            <a>{user.role}</a>
                            <h2>Статус аккаунта:</h2>
                            <a>{user.approval}</a>
                        </>
                    ))
                )}
            </div>
            </form>
        </div>
    </>
    )
}

export default CardOfAM;